import axios from 'axios'
import {ConfigParams} from '../../src/config'

const ingeoService = axios.create({
    baseURL: ConfigParams.API_URL + 'api/',
    timeout: 10000,
    headers: {'Content-Type': 'application/json'}
  });

export default ingeoService;
